import React from 'react'

import {getStatusTheme, statusLabel} from '../../../modes/attendance/attendanceStatusTheme'
import {AttendanceStatusSegment} from '../../../modes/attendance/buildAttendanceVisualSummary'

type AttendanceStatusPillsProps = {
  segments: AttendanceStatusSegment[]
  theme: 'light' | 'dark'
}

const AttendanceStatusPills: React.FC<AttendanceStatusPillsProps> = ({segments, theme}) => {
  if (!segments.length) return null

  return (
    <div className='attendance-status-pills d-flex flex-wrap gap-1'>
      {segments.map((seg) => {
        const styled = getStatusTheme(seg.label, theme)
        return (
          <span
            key={`${seg.key}-${seg.label}`}
            className='d-inline-flex align-items-center gap-1 rounded-pill px-2 py-1'
            style={{
              fontSize: '0.7rem',
              fontWeight: 600,
              color: styled.color,
              backgroundColor: styled.softBg,
              border: `1px solid ${styled.color}44`,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                backgroundColor: styled.color,
                flexShrink: 0,
              }}
            />
            {statusLabel(seg.label)} {seg.count}
          </span>
        )
      })}
    </div>
  )
}

export default AttendanceStatusPills
